const appConfigurationsPath = '/app/configuration/keys';

export const getConfigs = `${appConfigurationsPath}`;
export const getConfigById = (key: string) => `${appConfigurationsPath}/${key}`;
export const updateConfig = (key: string) => `${appConfigurationsPath}/${key}`;
